import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import 'mosha-vue-toastify/dist/style.css';

import App from "@/App.vue";
import Maska from "maska";
import { VueCookieNext } from "vue-cookie-next";
import { createApp } from "vue";
import { createHead } from '@vueuse/head'
import i18n from './lang'
import moshaToast from 'mosha-vue-toastify';
import router from "@/router/index";
import { store } from "./store";

const head = createHead()

router.beforeEach((to, from, next) => {
    next();
});

createApp(App)
    .use(i18n)
    .use(Maska)
    .use(head)
    .use(VueCookieNext)
    .use(moshaToast)
    .use(store)
    .use(router)
    .mount("#app");
